<div *ngIf="isVisible" style="background: #111827; padding: 20px; border-radius: 8px; border: 1px solid #2D3748; width: 100%; box-sizing: border-box;">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
    <h3 style="color: white; margin: 0; font-size: 18px;">Filter Sales Volume</h3>
    <button (click)="onCancel()" style="background: none; border: none; color: white; cursor: pointer; font-size: 20px;">&times;</button>
  </div>

  <!-- <div style="margin-bottom: 20px;">
    <label style="display: flex; align-items: center; color: white; font-size: 14px;">
      <input type="checkbox" [checked]="hideLocationWithoutSales" (change)="onHideLocationChange()" style="margin-right: 8px;">
      Hide Location Without Sales
    </label>
  </div> -->

  <div style="margin-bottom: 20px;">
    <h4 style="color: white; margin: 0 0 15px 0; font-size: 16px;">Sales Volume Range (weekly)</h4>
    <input type="range" [min]="900000" [max]="134500000" [value]="minValue" (input)="onSliderMinChange($any($event.target).value)" style="width: 100%; margin-bottom: 10px;">
    <input type="range" [min]="900000" [max]="134500000" [value]="maxValue" (input)="onSliderMaxChange($any($event.target).value)" style="width: 100%; margin-bottom: 15px;">

    <div style="display: flex; gap: 15px;">
      <div style="flex: 1;">
        <label style="color: white; display: block; margin-bottom: 5px; font-size: 14px;">Min</label>
        <input type="text" [value]="minInput" (input)="onMinInputChange($any($event.target).value)" style="width: 100%; padding: 8px; border: 1px solid #4A5568; border-radius: 4px; background: transparent; color: white; box-sizing: border-box;">
      </div>
      <div style="flex: 1;">
        <label style="color: white; display: block; margin-bottom: 5px; font-size: 14px;">Max</label>
        <input type="text" [value]="maxInput" (input)="onMaxInputChange($any($event.target).value)" style="width: 100%; padding: 8px; border: 1px solid #4A5568; border-radius: 4px; background: transparent; color: white; box-sizing: border-box;">
      </div>
    </div>
  </div>

  <div style="display: flex; gap: 10px; justify-content: flex-end; padding-top: 15px; border-top: 1px solid #2D3748;">
    <button (click)="onCancel()" style="padding: 8px 16px; background: #475467; color: white; border: none; border-radius: 4px; cursor: pointer;">Cancel</button>
    <button (click)="onApply()" style="padding: 8px 16px; background: #2965D2; color: white; border: none; border-radius: 4px; cursor: pointer;">Apply</button>
  </div>
</div>
